import React, {useEffect, useState} from 'react';

import AutocompleteDropdownComponentV2 from '../../../../common/genericComponents/autocompleteDropdownComponentV2';
import LoaderComponent from '../../../../common/genericComponents/redesign/loaderComponent/loaderComponent';
import InputComponentV2 from '../../../../common/genericComponents/redesign/inputComponentV2/inputComponentV2';
// import TitleComponentV2 from '../../../../common/genericComponents/redesign/titleComponentV2/titleComponentV2';

import c2cStripeTransactionsService from '../../../../../services/restServices/c2cStripeTransactionsService';
import paypalPaymentService from '../../../../../services/paypalPaymentService';
// import utilsService from '../../../../../services/utilsService';
import VIDABOO_CONSTANTS from '../../../../../config/consts';

import './sessionCostAndCurrencyComponent.css';

const SessionCostAndCurrencyComponent = ({
  isDisabled = false,
  billingPlanFeature = null,
  paypalEmail = null,
  sessionCost = 1,
  sessionCostToolTipTxt = null,
  sessionCurrency = null,
  sessionTemplateId = null,
  onSessionCostChanged = () => {},
  onSessionCostChangeFailed = () => {},
  onSessionCurrencyChanged = () => {},
  onSessionCurrencyChangeFailed = () => {},
  setIsPaypalAndStripeConfiguredProperly = () => {},
  setIsFetchingConfiguration = () => {},
}) => {
  const [paymentTransactionCurrencies, setPaymentTransactionCurrencies] =
    useState([]);
  const [isFetchingConfiguration, setIsFetchingConfigurationInt] =
    useState(false);

  useEffect(() => {
    let paymentTransactionCurrencies = [];
    for (const paymentTransactionCurrency of Object.keys(
      VIDABOO_CONSTANTS.PAYMENT_TRANSACTION_CURRENCIES,
    )) {
      paymentTransactionCurrencies.push({
        key: paymentTransactionCurrency,
        value: paymentTransactionCurrency,
      });
    }
    setPaymentTransactionCurrencies(paymentTransactionCurrencies);
  }, []);

  useEffect(() => {
    async function updateIsPaypalAndStripeConfiguredProperly() {
      let isConfigurationValid = await getIsConfigurationValid(sessionCurrency);
      setIsPaypalAndStripeConfiguredProperly(isConfigurationValid);
    }
    updateIsPaypalAndStripeConfiguredProperly();
  }, [paypalEmail, sessionCost, sessionCurrency, sessionTemplateId]);

  const handleSessionCostChanged = async (id, value) => {
    let isConfigurationValid = await getIsConfigurationValid(sessionCurrency);
    if (isConfigurationValid) {
      onSessionCostChanged(value);
    } else {
      onSessionCostChangeFailed();
    }
  };

  const handleSessionCurrencyChanged = async (value) => {
    let isConfigurationValid = await getIsConfigurationValid(value);

    if (isConfigurationValid) {
      onSessionCurrencyChanged(value);
    } else {
      onSessionCurrencyChangeFailed();
    }
  };
  const setFetchingConfiguration = (isSetting) => {
    setIsFetchingConfiguration(isSetting);
    setIsFetchingConfigurationInt(isSetting);
  };
  const getIsConfigurationValid = async (sessionCurrency) => {
    let isPaypalAvailable = false,
      isStripeAvailable = false;
    setFetchingConfiguration(true);
    try {
      isPaypalAvailable = await getIsPaypalConfigurationValid(sessionCurrency);
      console.debug('Paypal option is available');
    } catch (error) {
      console.debug('Paypal option not available');
    }
    if (!isPaypalAvailable) {
      try {
        isStripeAvailable = await getIsStripeConfigurationValid();
        console.debug('Stripe option is available');
      } catch (error) {
        console.debug('Stripe option not available');
      }
    }
    setFetchingConfiguration(false);
    return isPaypalAvailable || isStripeAvailable;
  };

  const getIsPaypalConfigurationValid = (sessionCurrency) => {
    return new Promise((resolve, reject) => {
      if (paypalEmail && sessionCurrency) {
        paypalPaymentService.verifyPaypalEmail(
          paypalEmail,
          sessionCurrency,
          () => {
            resolve(true);
          },
          () => {
            reject(false);
          },
        );
      } else {
        reject(false);
      }
    });
  };

  const getIsStripeConfigurationValid = () => {
    return new Promise((resolve, reject) => {
      if (sessionTemplateId) {
        const testStripePaymentIntentPayload = {
          sessionTemplateId,
          paymentFlowType:
            VIDABOO_CONSTANTS.C2C_MONEY_TRANSACTION_PAYMENT_FLOW_TYPE
              .DURING_CHAT,
        };
        c2cStripeTransactionsService
          .testStripePaymentIntent(testStripePaymentIntentPayload)
          .then((response) => {
            if (response?.success) {
              resolve(true);
            } else {
              reject(false);
            }
          })
          .catch(() => {
            reject(false);
          });
      } else {
        reject(false);
      }
    });
  };

  return (
    <>
      <div className="et-n-ers-session-cost-currency-container">
        <div className="et-n-ers-scc-session-cost-wrap">
          <InputComponentV2
            id="sessionCost"
            disabled={isDisabled}
            billingPlanFeature={billingPlanFeature}
            defaultValue={
              sessionCost ?? VIDABOO_CONSTANTS.PAYMENT_AMOUNT.MIN_VALUE
            }
            minValue={VIDABOO_CONSTANTS.PAYMENT_AMOUNT.MIN_VALUE}
            maxValue={VIDABOO_CONSTANTS.C2C_MAX_TRANSACTION_VALUE}
            inputType="number"
            // LeftComponent={
            //   <TitleComponentV2
            //     titleTxt={utilsService.getCurrencySymbol(sessionCurrency)}
            //   />
            // }
            titleTxt="How much per session?"
            toolTipTxt={sessionCostToolTipTxt}
            onChange={handleSessionCostChanged}
          />
        </div>
        <div className="et-n-ers-ssc-session-currency-wrap">
          <AutocompleteDropdownComponentV2
            isDisabled={isDisabled}
            billingPlanFeature={billingPlanFeature}
            titleTxt="Select currency"
            titleTooltipTxt="Select the currency of the transaction. Make sure your Stripe or Paypal account support this currency."
            labelKey="value"
            options={paymentTransactionCurrencies}
            value={sessionCurrency}
            valueKey="key"
            selectedOption={(e) => handleSessionCurrencyChanged(e.target.value)}
          />
        </div>
      </div>
      {isFetchingConfiguration && (
        <div className="et-n-ers-ssc-loader">
          <LoaderComponent />
        </div>
      )}
    </>
  );
};

export default SessionCostAndCurrencyComponent;
